@if (modelSig()) {
    @if (modelSig().hasChildren) {
        <span
            class="clickable fa fa-caret-down p-1"
            [ngClass]="{ '-rotate-90': modelSig().childrenHidden() }"
            (click)="toggleChildren()"
        ></span>
    }
    <!-- TODO, tune ml -->
    <span [ngClass]="{ 'ml-3': modelSig().parentId != null && !modelSig().hasChildren }">{{
        modelSig().positionText
    }}</span>
}
